module.exports = __webpack_public_path__ + "img/shopify_logo.305ff4da.png";